// ============================================================================
// api.jquery.js — Shopify AJAX Cart Helpers (TRIMMED)
// ============================================================================
//
// PREVIOUS VERSION of this file contained:
//   - freeGifts array (hardcoded tier config, duplicated from free-gift-config)
//   - withinTimeframe() helper
//   - checkFreeGifts() with the expired $50 timeframe bug
//   - Shopify.onCartUpdate() with its own updateFreeGiftUI() inner function
//   - Initial Shopify.getCart(checkFreeGifts) trigger
//
// ALL of that is now handled by assets/cart.js + snippets/free-gift-config.liquid.
// This file now contains ONLY the generic Shopify.* AJAX helpers that legacy
// theme code may still call. Those helpers are overridden at runtime by
// cart.js's compat shim, so calls to Shopify.addItem/changeItem/etc. are
// automatically routed through MODACart.
//
// This file exists purely for backwards compatibility. If nothing in the theme
// references Shopify.addItem/changeItem/removeItem/updateItem/getCart anymore,
// this file can be deleted entirely.
// ============================================================================

// 1) Ensure Shopify namespace
if (typeof Shopify === 'undefined') {
  Shopify = {};
}

// 2) Error handlers
Shopify.onError = function(xhr, status) {
  try {
    var err = JSON.parse(xhr.responseText);
    if (err.message) {
      alert(err.message + " (" + xhr.status + "): " + err.description);
    } else {
      alert("Error: " + Shopify.fullMessagesFromErrors(err).join("; ") + ".");
    }
  } catch (e) {
    console.error("Error parsing JSON response:", e, xhr.responseText);
    alert("An unexpected error occurred. Please try again.");
  }
};

Shopify.fullMessagesFromErrors = function(errors) {
  var msgs = [];
  jQuery.each(errors, function(field, arr) {
    jQuery.each(arr, function(_, m) { msgs.push(field + " " + m); });
  });
  return msgs;
};

// 3) Currency formatting fix (for GBP stores)
$(function() {
  if (
    Shopify.currency &&
    Shopify.currency.active === 'GBP' &&
    Shopify.money_format.indexOf('£') === -1
  ) {
    Shopify.money_format = '£{{amount}}';
  }
});

// ----------------------------------------------------------------------------
// LEGACY SHOPIFY.* AJAX HELPERS
// ----------------------------------------------------------------------------
// These are overridden at runtime by cart.js's compat shim, but left here so
// that legacy code calling these functions before cart.js loads (edge case)
// still works via the original implementation.
// ----------------------------------------------------------------------------

Shopify.addItem = function(items, callback) {
  items = Array.isArray(items) ? { items: items } : { items: [items] };
  items.items.forEach(function(i) { i.quantity = i.quantity || 1; });

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: items,
    dataType: "json",
    success: function(res) {
      if (typeof callback === "function") callback(res);
    },
    error: Shopify.onError
  });
};

Shopify.getCart = function(callback) {
  jQuery.getJSON("/cart.js", function(cart) {
    if (typeof callback === "function") callback(cart);
  });
};

Shopify.changeItem = function(id, qty, key, cb) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=" + qty + "&" + key + "=" + id,
    dataType: "json",
    success: function(res) {
      if (typeof cb === "function") cb(res);
    },
    error: Shopify.onError
  });
};

Shopify.removeItem = function(id, key, cb) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: "quantity=0&" + key + "=" + id,
    dataType: "json",
    success: function(res) {
      if (typeof cb === "function") cb(res);
    },
    error: Shopify.onError
  });
};

Shopify.updateItem = function(updates, cb) {
  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: { updates: updates },
    dataType: "json",
    success: function(res) {
      if (typeof cb === "function") cb(res);
    },
    error: Shopify.onError
  });
};

// Legacy queue helpers (still referenced by some third-party code)
Shopify.queue = [];
Shopify.moveAlong = function() {
  if (Shopify.queue.length) {
    var req = Shopify.queue.shift();
    Shopify.addItem(
      { id: req.variantId, quantity: req.quantity, properties: req.properties },
      Shopify.moveAlong
    );
  }
};

function push_to_queue(id, qty, props, cb) {
  Shopify.queue.push(
    props
      ? { variantId: id, quantity: qty, properties: props }
      : { variantId: id, quantity: qty }
  );
  if (typeof cb === "function") cb();
}